 <div class="dynamic-field form-button" [formGroup]="group">
   <button [disabled]="config.disabled" type="submit">
     {{config.label|translate}}
   </button>
 </div>
